import React, { useState } from 'react';
function CaloriesTable({ caloriesBurned, bmr, maintain, mildLoss, lose, extremeLoss, mildGain, gain, extremeGain }) {
  return (
    <table >
      <thead>
        <tr>
          <th >حالة إدارة الوزن</th>
          <th > السعرات الحرارية (يومياً)</th>
        </tr>
      </thead>
      <tbody>
        <tr >
          <td>الحفاظ على الوزن</td>
          <td>{maintain} </td>
        </tr>
        <tr >
          <td>فقدان وزن طفيف (0.25 كغ/إسبوعياً)</td>
          <td>{mildLoss} </td>
        </tr>
        <tr >
          <td>فقدان الوزن (0.5 كغ/إسبوعياً)</td>
          <td>{lose} </td>
        </tr>
        <tr >
          <td>فقدان الوزن المفرط (1 كغ/إسبوعياً)</td>
          <td>{extremeLoss} </td>
        </tr>
        <tr >
          <td>زيادة الوزن الطفيف (0.25 كغ/إسبوعياً)
          </td>
          <td>{mildGain} </td>
        </tr>
        <tr >
          <td>زيادة الوزن (0.5 كغ/إسبوعياً)</td>
          <td>{gain} </td>
        </tr>
        <tr >
          <td>زيادة الوزن السريعة (1 كغ/إسبوعياً)</td>
          <td>{extremeGain} </td>
        </tr>
        <tr >
          <td colSpan="2">إجمالي السعرات الحرارية المستهلكة/المحروقة : {caloriesBurned} (يومياً) </td>
        </tr>
        <tr  >
          <td colSpan="2"> معدل الأيض الأساسي BMR هو : {bmr} </td>
        </tr>
      </tbody>
    </table>
  );
}
export default CaloriesTable;
